const CUB_METERS_PER_DAY_TO_SCFH = 1.471;
const CUB_METERS_PER_DAY_TO_SCMD = 1;

const CUB_METERS_TO_CUB_METERS = 1;
const CUB_METERS_TO_CUB_FEET = 35.3147;

const MET_PER_SEC_TO_MPH = 2.23694;
const MET_PER_SEC_TO_KMH = 3.6;
const MET_PER_SEC_TO_MPS = 1;

const units = Object.freeze({
  TEMPERATURE: {
    FAHRENHEIT: "°F",
    CELCIUS: "°C"
  },
  WIND: {
    MILES_PER_HOUR: "mph",
    KILOMETERS_PER_HOUR: "km/h",
    METERS_PER_SECOND: "m/s"
  },
  LEAKRATE: {
    STANDARD_CUBIC_FEET_PER_HOUR: "SCFH",
    STANDARD_CUBIC_METERS_PER_HOUR: "SCMH",
    STANDARD_CUBIC_METERS_PER_DAY: "Sm³/d"
  },
  VOLUME: {
    STANDARD_CUBIC_METERS: "m³",
    STANDARD_CUBIC_FEET: "ft³"
  }
});

const MILES_PER_HOUR = "MILES_PER_HOUR";
const KILOMETERS_PER_HOUR = "KILOMETERS_PER_HOUR";
const METERS_PER_SECOND = "METERS_PER_SECOND";
const CUBIC_METERS_PER_DAY = "CUBIC_METERS_PER_DAY";
const ALGO_CUBIC_METERS_PER_DAY = "ALGO_CUBIC_METERS_PER_DAY";

const STANDARD_CUBIC_FEET_PER_HOUR = "STANDARD_CUBIC_FEET_PER_HOUR";
const STANDARD_CUBIC_METERS_PER_HOUR = "STANDARD_CUBIC_METERS_PER_HOUR";
const STANDARD_CUBIC_METERS_PER_DAY = "STANDARD_CUBIC_METERS_PER_DAY";

const STANDARD_CUBIC_METERS = "STANDARD_CUBIC_METERS";
const STANDARD_CUBIC_FEET = "STANDARD_CUBIC_FEET";

const FAHRENHEIT = "FAHRENHEIT";
const CELCIUS = "CELCIUS";

const UnitNames = Object.freeze({
  [MILES_PER_HOUR]: "mph",
  [KILOMETERS_PER_HOUR]: "km/h",
  [METERS_PER_SECOND]: "m/s",
  [STANDARD_CUBIC_METERS_PER_DAY]: "Sm³/d",
  [STANDARD_CUBIC_FEET_PER_HOUR]: "SCFH",
  [STANDARD_CUBIC_METERS]: "Sm³",
  [STANDARD_CUBIC_FEET]: "SCF",
  [FAHRENHEIT]: "°F",
  [CELCIUS]: "°C",
  // Units of Measurement names used for Quantification Results:
  [ALGO_CUBIC_METERS_PER_DAY]: "m3/d"
});

// base wind speed unit is m/s
const WindSpeedMultiplier = {
  [UnitNames.MILES_PER_HOUR]: MET_PER_SEC_TO_MPH,
  [UnitNames.KILOMETERS_PER_HOUR]: MET_PER_SEC_TO_KMH,
  [UnitNames.METERS_PER_SECOND]: MET_PER_SEC_TO_MPS
};

// base leak rate unit is m3/d
const LeakRateMultiplier = {
  [UnitNames.STANDARD_CUBIC_FEET_PER_HOUR]: CUB_METERS_PER_DAY_TO_SCFH,
  [UnitNames.STANDARD_CUBIC_METERS_PER_DAY]: CUB_METERS_PER_DAY_TO_SCMD,
  [UnitNames.ALGO_CUBIC_METERS_PER_DAY]: CUB_METERS_PER_DAY_TO_SCMD
};

const VolumeMultiplier = {
  [UnitNames.STANDARD_CUBIC_METERS]: CUB_METERS_TO_CUB_METERS,
  [UnitNames.STANDARD_CUBIC_FEET]: CUB_METERS_TO_CUB_FEET
};

const LeakRateUnitToVolumeUnit = {
  [UnitNames.STANDARD_CUBIC_FEET_PER_HOUR]: UnitNames.STANDARD_CUBIC_FEET,
  [UnitNames.STANDARD_CUBIC_METERS_PER_DAY]: UnitNames.STANDARD_CUBIC_METERS,
  [UnitNames.ALGO_CUBIC_METERS_PER_DAY]: UnitNames.STANDARD_CUBIC_METERS
};

// base temperature unit is °C
const TemperatureMultiplier = {
  [UnitNames.FAHRENHEIT]: celsius => (celsius * 9) / 5 + 32,
  [UnitNames.CELCIUS]: celsius => celsius
};

const T_SHIRT_SIZES = {
  0: "N/A",
  1: "Small",
  2: "Medium",
  3: "Large",
  4: "Super"
};

module.exports = {
  // Imperial units
  MILES_PER_HOUR,
  STANDARD_CUBIC_FEET_PER_HOUR,
  STANDARD_CUBIC_FEET,
  FAHRENHEIT,
  // Metric units
  KILOMETERS_PER_HOUR,
  METERS_PER_SECOND,
  CUBIC_METERS_PER_DAY,
  STANDARD_CUBIC_METERS_PER_HOUR,
  STANDARD_CUBIC_METERS_PER_DAY,
  STANDARD_CUBIC_METERS,
  CELCIUS,

  CUB_METERS_PER_DAY_TO_SCFH,
  CUB_METERS_PER_DAY_TO_SCMD,
  MET_PER_SEC_TO_MPH,
  MET_PER_SEC_TO_KMH,
  MET_PER_SEC_TO_MPS,
  units,
  UnitNames,

  WindSpeedMultiplier,
  LeakRateMultiplier,
  TemperatureMultiplier,
  VolumeMultiplier,

  LeakRateUnitToVolumeUnit,

  T_SHIRT_SIZES
};
